export const iconFontAwesomeUsersPeopleHeadSideCough = (
	<i className="fa-solid fa-head-side-cough"></i>
);
